import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['item', 'command', 'list', 'button', 'groupTitle', 'divider'];
var baseStyleList = {
  borderRadius: 'none',
  boxShadow: '0 0 8px 0 rgb(0 0 0 / 10%), 0 0 40px 0 rgb(0 0 0 / 12%)',
  border: 'none'
};
var baseStyleItem = {
  textDecoration: 'none',
  fontWeight: 'bold',
  _focus: {
    bg: "yellow.200",
    color: 'black'
  },
  _notLast: {
    borderBottom: '1px solid #E5E5E5'
  }
};
var baseStyle = {
  list: baseStyleList,
  item: baseStyleItem
};
export var Menu = asMultiStyleConfig({
  parts,
  baseStyle
});